<template>
	<div v-if="mounted" :class="slideInClass">
		<header class="titled">
			<div>
				<h4 v-html="title || sectionToEdit.label"/>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="close(false)">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<div v-if="!sectionToEdit">Wähle aus was du bearbeiten möchtest.</div>
			<template v-else>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'employment-mode'"
					v-model="sectionData"
					:characteristic-items="meta.employmentMode"
					initial-show-all
					label-type="application"
					show-multiple-hint
				/>
				<Functions
					v-if="sectionToEdit && sectionToEdit.id === 'function'"
					v-model="sectionData"
					:employment-modes="employmentModes"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'function-assistance'"
					v-model="sectionData"
					:characteristic-items="meta.functionAssistance"
					:characteristic-type="meta.functionAssistanceType"
					:nothing-allowed="{
						text: 'Egal - es sind alle Tätigkeiten erwünscht'
					}"
					initial-show-all
					label-type="application"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'function-marketing-role'"
					v-model="sectionData"
					:characteristic-items="meta.functionMarketingRole"
					:characteristic-type="meta.functionMarketingRoleType"
					:nothing-allowed="{
						text: 'Egal - es sind alle Tätigkeiten erwünscht'
					}"
					initial-show-all
					label-type="application"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'function-legal-field'"
					v-model="sectionData"
					:characteristic-items="meta.functionLegalField"
					:characteristic-type="meta.functionLegalFieldType"
					:nothing-allowed="{
						text: 'Egal - es sind alle Rechtsgebiete erwünscht'
					}"
					initial-show-all
					label-type="application"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'function-legal-role'"
					v-model="sectionData"
					:characteristic-items="meta.functionLegalRole"
					:characteristic-type="meta.functionLegalRoleType"
					:nothing-allowed="{
						text: 'Egal - es sind alle Rechtstätigkeiten erwünscht'
					}"
					initial-show-all
					label-type="application"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'function-tax-field'"
					v-model="sectionData"
					:characteristic-items="meta.functionTaxField"
					:characteristic-type="meta.functionTaxFieldType"
					:nothing-allowed="{
						text: 'Egal - es sind alle Steuergebiete erwünscht'
					}"
					initial-show-all
					label-type="application"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'function-tax-role'"
					v-model="sectionData"
					:characteristic-items="meta.functionTaxRole"
					:characteristic-type="meta.functionTaxRoleType"
					:nothing-allowed="{
						text: 'Egal - es sind alle Steuertätigkeiten erwünscht'
					}"
					initial-show-all
					label-type="application"
				/>
				<WorkingTime
					v-if="sectionToEdit && sectionToEdit.id === 'working-time'"
					v-model="sectionData"
				/>
				<HomeOffice
					v-if="sectionToEdit && sectionToEdit.id === 'home-office'"
					v-model="sectionData"
				/>
				<Geo
					v-if="sectionToEdit && sectionToEdit.id === 'geo'"
					v-model="sectionData"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'career-level'"
					v-model="sectionData"
					:characteristic-items="meta.careerLevel"
					initial-show-all
					show-multiple-hint
					label-type="application"
				/>
				<IndustrialSectors
					v-if="sectionToEdit && sectionToEdit.id === 'industrial-sector'"
					v-model="sectionData"
					:nothing-allowed="industrialSectorsNothingAllowed"
				/>
				<OrganisationalArea
					v-if="sectionToEdit && sectionToEdit.id === 'organisational-area'"
					v-model="sectionData"
					:functions="job.functions"
				/>
				<Salary
					v-if="sectionToEdit && sectionToEdit.id === 'salary'"
					v-model="sectionData"
					:employment-modes="employmentModes"
				/>
				<HourlyRate
					v-if="sectionToEdit && sectionToEdit.id === 'hourly-rate'"
					v-model="sectionData"
					:employment-modes="employmentModes"
				/>
				<WorkingHours
					v-if="sectionToEdit && sectionToEdit.id === 'working-hours'"
					v-model="sectionData"
				/>
				<EmploymentDuration
					v-if="sectionToEdit && sectionToEdit.id === 'employment-duration'"
					v-model="sectionData"
				/>
				<StartDate
					v-if="sectionToEdit && sectionToEdit.id === 'start-date'"
					v-model="sectionData"
				/>
				<SearchStatus
					v-if="sectionToEdit && sectionToEdit.id === 'search-status'"
					v-model="sectionData"
				/>
				<Parking
					v-if="sectionToEdit && sectionToEdit.id === 'parking'"
					v-model="sectionData"
				/>
				<PublicTransport
					v-if="sectionToEdit && sectionToEdit.id === 'public-transport'"
					v-model="sectionData"
				/>
				<PrivateVehicleCompanyUsage
					v-if="sectionToEdit && sectionToEdit.id === 'private-vehicle-company-usage'"
					v-model="sectionData"
				/>
				<CompanyCar
					v-if="sectionToEdit && sectionToEdit.id === 'company-car'"
					v-model="sectionData"
				/>
				<CustomerContact
					v-if="sectionToEdit && sectionToEdit.id === 'customer-contact'"
					v-model="sectionData"
				/>
				<TravelWillingness
					v-if="sectionToEdit && sectionToEdit.id === 'travel-willingness'"
					v-model="sectionData"
					:meta="meta"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'company-type'"
					v-model="sectionData"
					multiple
					initial-show-all
					:characteristic-items="meta.companyType"
					:nothing-allowed="{
						text: 'Egal - alle sind möglich'
					}"
					show-multiple-hint
					label-type="application"
				/>
				<CharacteristicSelectInline
					v-if="sectionToEdit && sectionToEdit.id === 'company-size'"
					v-model="sectionData"
					multiple
					initial-show-all
					:characteristic-items="meta.companySize"
					:nothing-allowed="{
						text: 'Egal - alle sind möglich'
					}"
					show-multiple-hint
					label-type="application"
				/>
				<Management
					v-if="sectionToEdit && sectionToEdit.id === 'management'"
					v-model="sectionData"
				/>
				<Overtime
					v-if="sectionToEdit && sectionToEdit.id === 'overtime'"
					v-model="sectionData"
				/>
				<Relocation
					v-if="sectionToEdit && sectionToEdit.id === 'relocation'"
					v-model="sectionData"
				/>
			</template>
		</main>
		<footer>
			<Button
				v-if="sectionToEdit"
				text="Speichern"
				:disabled="!sectionDataValid || saving"
				:loading="saving"
				icon="checkmark"
				@click="save"
			/>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Functions from "@/vue/application/Functions.vue"
import Icon from "@/vue/icon/Icon";
import CharacteristicEdit from "@/vue/characteristic/Edit"
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline"
import Button from "@/vue/common/Button";
import JobSave from "@/api/job/Save";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import _ from "lodash";
import * as Preparation from "@/helper/application/Preparation";
import Salary from "@/vue/application/Salary";
import HourlyRate from "@/vue/application/HourlyRate";
import WorkingHours from "@/vue/application/WorkingHours";
import StartDate from "@/vue/application/StartDate";
import SearchStatus from "@/vue/application/SearchStatus";
import PublicTransport from "@/vue/application/PublicTransport";
import PrivateVehicleCompanyUsage from "@/vue/application/PrivateVehicleCompanyUsage";
import CustomerContact from "@/vue/application/CustomerContact";
import TravelWillingness from "@/vue/application/TravelWillingness";
import Management from "@/vue/application/Management";
import Overtime from "@/vue/application/Overtime";
import Relocation from "@/vue/application/Relocation";
import HomeOffice from "@/vue/application/HomeOffice";
import * as Log from "@/helper/Log";
import * as Section from "@/helper/application/Section"
import CompanyCar from "@/vue/application/CompanyCar";
import EmploymentDuration from "@/vue/application/EmploymentDuration";
import WorkingTime from "@/vue/application/WorkingTime";
import {characteristicsValue} from "@/helper/job/Fan";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job/edit";
import Parking from "@/vue/application/Parking.vue";
import IndustrialSectors from "@/vue/application/IndustrialSectors.vue";
import Geo from "@/vue/application/Geo";
import {isMandatory} from "@/helper/characteristic/IndustrialSector";
import OrganisationalArea from "@/vue/application/OrganisationalArea.vue";

const SECTIONS = {
	[Section.EMPLOYMENT_MODE]: {
		property: 'employmentModes',
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.FUNCTION]: {
		property: 'functions',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.functions,
				meta,
				'function',
				'functionType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.FUNCTION_ASSISTANCE]: {
		property: 'functionAssistance',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.functionAssistance,
				meta,
				'functionAssistance',
				'functionAssistanceType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.FUNCTION_MARKETING_ROLE]: {
		property: 'functionMarketingRole',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.functionMarketingRole,
				meta,
				'functionMarketingRole',
				'functionMarketingRoleType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.FUNCTION_LEGAL_FIELD]: {
		property: 'functionLegalField',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.functionLegalField,
				meta,
				'functionLegalField',
				'functionLegalFieldType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.FUNCTION_LEGAL_ROLE]: {
		property: 'functionLegalRole',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.functionLegalRole,
				meta,
				'functionLegalRole',
				'functionLegalRoleType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.FUNCTION_TAX_FIELD]: {
		property: 'functionTaxField',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.functionTaxField,
				meta,
				'functionTaxField',
				'functionTaxFieldType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.FUNCTION_TAX_ROLE]: {
		property: 'functionTaxRole',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.functionTaxRole,
				meta,
				'functionTaxRole',
				'functionTaxRoleType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.WORKING_TIME]: {
		property: 'workingTime',
		value: ({job, meta}) =>
		{
			return {
				workingTime: characteristicsValue(
					job.workingTime?.workingTime,
					meta,
					'workingTime',
					'workingTimeType'
				)
			};
		},
		prepare: (itemData) => Preparation.prepareWorkingTime(itemData)
	},
	[Section.GEO]: {
		property: 'geo',
		value: ({job, meta}) =>
		{
			return characteristicsValue(job.geo, meta, 'geo', 'geoType');
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.HOME_OFFICE]: {
		property: 'homeOffice',
		value: ({job}) => job.homeOffice,
	},
	[Section.CAREER_LEVEL]: {
		property: 'careerLevels',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.careerLevels,
				meta,
				'careerLevel',
				'careerLevelType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.INDUSTRIAL_SECTOR]: {
		property: 'industrialSectors',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.industrialSectors,
				meta,
				'industrialSector',
				'industrialSectorType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.ORGANISATIONAL_AREA]: {
		property: 'organisationalArea',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.organisationalArea,
				meta,
				'organisationalArea',
				'organisationalAreaType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.SALARY]: {
		property: 'salary',
		value: ({job}) => job.salary
	},
	[Section.HOURLY_RATE]: {
		property: 'hourlyRate',
		value: ({job}) => job.hourlyRate
	},
	[Section.WORKING_HOURS]: {
		property: 'workingHours',
		value: ({job}) => job.workingHours,
	},
	[Section.EMPLOYMENT_DURATION]: {
		property: 'employmentDuration',
		value: ({job}) => job.employmentDuration,
	},
	[Section.START_DATE]: {
		property: 'startDate',
		value: ({job}) => job.startDate
	},
	[Section.SEARCH_STATUS]: {
		property: 'searchStatus',
		value: ({job}) => job.searchStatus,
		prepare: (itemData) => Preparation.prepareSearchStatus(itemData)
	},
	[Section.PARKING]: {
		property: 'parking',
		value: ({job}) => job.parking,
		prepare: (itemData) => Preparation.prepareParking(itemData)
	},
	[Section.PUBLIC_TRANSPORT]: {
		property: 'publicTransport',
		value: ({job, meta}) =>
		{
			return {
				publicTransport: characteristicsValue(
					job.publicTransport?.publicTransport,
					meta,
					'publicTransport',
					'publicTransportType'
				)
			};
		},
		prepare: (itemData) => Preparation.preparePublicTransport(itemData)
	},
	[Section.PRIVATE_VEHICLE_COMPANY_USAGE]: {
		property: 'privateVehicleCompanyUsage',
		value: ({job}) => job.privateVehicleCompanyUsage
	},
	[Section.COMPANY_CAR]: {
		property: 'companyCar',
		value: ({job}) => job.companyCar
	},
	[Section.CUSTOMER_CONTACT]: {
		property: 'customerContact',
		value: ({job}) => job.customerContact,
		prepare: (itemData) => Preparation.prepareCustomerContact(itemData)
	},
	[Section.TRAVEL_WILLINGNESS]: {
		property: 'travelWillingness',
		value: ({job}) => job.travelWillingness,
		prepare: (itemData) => Preparation.prepareTravelWillingness(itemData)
	},
	[Section.COMPANY_TYPE]: {
		property: 'companyType',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.companyType,
				meta,
				'companyType',
				'companyTypeType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.COMPANY_SIZE]: {
		property: 'companySize',
		value: ({job, meta}) =>
		{
			return characteristicsValue(
				job.companySize,
				meta,
				'companySize',
				'companySizeType'
			);
		},
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData)
	},
	[Section.MANAGEMENT]: {
		property: 'management',
		value: ({job}) => job.management,
		prepare: (itemData) => Preparation.prepareManagement(itemData)
	},
	[Section.OVERTIME]: {
		property: 'overtime',
		value: ({job}) => job.overtime,
		prepare: (itemData) => Preparation.prepareOvertime(itemData)
	},
	[Section.RELOCATION]: {
		property: 'relocation',
		value: ({job}) => job.relocation,
		prepare: (itemData) => Preparation.prepareRelocation(itemData)
	},
};

export default {

	components: {
		OrganisationalArea,
		Geo,
		IndustrialSectors,
		Functions,
		Parking,
		WorkingTime,
		EmploymentDuration,
		CompanyCar,
		HomeOffice,
		Relocation,
		Management,
		Overtime,
		TravelWillingness,
		CustomerContact,
		PrivateVehicleCompanyUsage,
		PublicTransport,
		StartDate,
		WorkingHours,
		Salary,
		HourlyRate,
		Icon,
		Button,
		CharacteristicEdit,
		CharacteristicSelectInline,
		SearchStatus,
	},

	data ()
	{
		return {
			sectionToEdit: undefined,
			sectionData: undefined,
			saving: false,
			modifiedData: {},
			sectionCompletions: [],
			mounted: false,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		...mapState('layout', ['fanLevelClasses']),
		...mapState('job/edit', [
			'show',
			'job',
			'title',
			'initialData',
			'onSave',
		]),
		...mapState('job/edit', {
			initialSectionToEdit: 'sectionToEdit'
		}),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		sectionDataValid ()
		{
			return this.sectionData !== undefined;
		},
		employmentModes ()
		{
			return _.map(this.job.employmentMode, 'item');
		},
		industrialSectorsNothingAllowed ()
		{
			return !isMandatory(
				this.job.functions.map(item => item.item)
			);
		},
	},

	methods: {
		...mapActions('job/edit', {
			closeFan: 'close'
		}),
		getSectionConfig (section)
		{
			return SECTIONS[section.id];
		},
		close (confirmed)
		{
			this.mounted = false;

			this.closeFan({
				confirmed
			});
		},
		async save ()
		{
			this.saving = true;

			this.modifiedData[this.sectionToEdit.id] = this.sectionData;

			let itemData = _.cloneDeep(this.sectionData);

			const sectionConfig = this.getSectionConfig(this.sectionToEdit);

			if (sectionConfig.prepare)
			{
				itemData = sectionConfig.prepare(itemData);
			}

			try
			{
				await new JobSave()
					.setJobId(this.job.id)
					.setData({
						[sectionConfig.property]: itemData
					})
					.call();

				if (this.onSave)
				{
					this.onSave({
						job: this.job
					});
				}

				if (!_.includes(this.sectionCompletions, this.sectionToEdit.id))
				{
					this.sectionCompletions.push(this.sectionToEdit.id);
				}

				Toast.success(this, ['Erfolgreich gespeichert']);

				this.close(true);
			}
			catch (e)
			{
				Log.error(e);

				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		},
	},

	watch: {
		job (job)
		{
			if (job)
			{
				this.sectionCompletions = this.job.sectionCompletions;
				this.sectionData = this.initialData;
				this.sectionToEdit = this.initialSectionToEdit;

				this.mounted = true;
			}
		}
	}
}
</script>
